import { HeaderDrowning } from '../components/HeaderDrowning';
import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { spineLoader } from '@play-co/timestep-spine';
import { downscale } from 'src/conf/scale';

const assetMap = {
  iconSmall: 'assets/minigame/rescueLevel/theme-drowning/icon_small.png',
  iconLarge: 'assets/minigame/rescueLevel/theme-drowning/icon_large.png',
  dream: 'assets/minigame/rescueLevel/theme-drowning/dream.png',
  headerBg: {
    loadMethod: spineLoader,
    url: 'assets/minigame/rescueLevel/theme-drowning/animation/drowning.background',
  },
  headerFg: {
    loadMethod: spineLoader,
    url: 'assets/minigame/rescueLevel/theme-drowning/animation/drowning.foreground',
  },
};

export const rescueLevelThemeDrowning = {
  getHeader: (opts: ViewOpts) => new HeaderDrowning(opts),
  getAssets: () => Object.values(assetMap),
  getDream: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.dream,
      width: downscale(336),
      height: downscale(175),
      offsetX: -downscale(336) / 2,
      offsetY: -downscale(175) / 2 - 20,
      ...opts,
    });
  },
  getIconLarge: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.iconLarge,
      width: downscale(571),
      height: downscale(460),
      offsetX: -downscale(571) / 2 + 40,
      offsetY: -downscale(460) / 2,
      anchorX: -downscale(571) / 2 + 40,
      anchorY: -downscale(460) / 2,
      ...opts,
    });
  },
  getIconSmall: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.iconSmall,
      width: downscale(178),
      height: downscale(142),
      offsetX: -downscale(178) / 2,
      offsetY: -downscale(142) / 2,
      anchorX: -downscale(178) / 2,
      anchorY: -downscale(142) / 2,
      ...opts,
    });
  },
  getHeaderBg: () => assetMap.headerBg.url,
  getHeaderFg: () => assetMap.headerFg.url,
};
